import form from './form';
import notifications from './notifications';
import { Router } from '@/legacy/Router';

Router.get('notification/:any', form);
Router.get('notification', notifications);
